<template>
    <div id="NoSoldProductReport">

        <v-row class="mb-2 ml-0">
            <v-icon @click="$router.go(-1)" class="mr-2">mdi-arrow-left</v-icon>
            Reports <v-icon size="16" class="ml-2">mdi-greater-than</v-icon> <span class="font-weight-bold ml-2">{{$route.name}}</span>
        </v-row>

        <v-row>
            <v-col cols="12" class="ml-4 d-inline-flex">
                <span class="last-label">LAST</span> <v-text-field class="last-day-field" type="number" dense v-model="lastDays"/>
                <Span class="last-label">DAYS</Span>
                <!--<v-text-field clearable label="Search Products" outlined v-model="search"></v-text-field>-->
                <v-select outlined dense class="branch-field" :items="warehousesArr" v-model="selectedWarehouse"
                          item-text="name" item-value="id" label="Branch"/>
                <v-btn depressed class="primary" @click="getReportData()" :disabled="disableApplyBtn">Apply</v-btn>
                <v-spacer/>
                <v-checkbox class="hide-product-checkbox" v-model="hideZeroStockProduct" label="Hide Zero Stock Product"/>
            </v-col>
            <v-spacer/>
            <!-- <v-btn class="mr-2" @click="exportCsv" color="primary">Export CSV</v-btn> -->

            <v-col cols="12" style="margin-top: -40px">
                <v-data-table @update:items-per-page="updatePageItems" @update:page="updatePageNextPrev" :loading="$apollo.queries.products.loading"
                              :headers="headers" :items="products" :search="search" :server-items-length="productCount"
                              :footer-props="{itemsPerPageOptions:rowsPerPageItems}" :items-per-page="itemsPerPage"
                              :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                    <template v-slot:no-data>No Products Available</template>
                    <template v-slot:no-results>No Products Available</template>
                    <template v-slot:item.name="{ item }">
                        <v-avatar tile class="my-3 avatar mr-6" style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click.stop="openGallery(item.Attachments)" title="View Image">
                            <v-img v-if="item.Attachments.length" :src="imgWpx(item.Attachments[0].path, 200)" alt="image">
                                <template v-slot:placeholder>
                                    <v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                                    <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                </template>
                            </v-img>
                        </v-avatar>
                        <span class="ellipsis product-name">
                            <span :title="item.name">{{ item.name || '-'}}</span><br>
                            <span :title="item.sku" class="f-12 grey--text text--darken-1">{{item.sku || '-'}}</span>
                        </span>
                    </template>
                   <!-- <template v-slot:item.productCategory="{ item }">
                      {{ item.ProductCategory?item.ProductCategory.name:'-' }}
                    </template> -->
                    <template v-slot:item.stock="{ item }">
                        {{ item.WarehouseStock.length?item.WarehouseStock[0].totalQty:'0' }}
                    </template>
                    <template v-slot:item.displayPrice="{ item }">
                        {{ item.displayPrice | currencyFilter}}
                    </template>
                    <template v-slot:item.totalAmount="{ item }">
                        {{ (item.WarehouseStock.length?item.WarehouseStock[0].totalQty * item.displayPrice:'0') | currencyFilter}}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <gallery id="gallery-no-sold-products" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"></gallery>
    </div>
</template>

<script>
    import {SUBSCRIBE_NO_SOLD_PRODUCTS_COUNT} from "../../graphql/subscriptions/Products";
    import Constants from "../../Constants/Constants";
    import {GET_NO_SOLD_PRODUCTS} from "../../graphql/queries/Products";
    import {
        no_sold_products_aggregate,
        no_sold_products_count_statement,
        no_sold_products_statement,
    } from "../../graphql/customStatement";
    import moment from 'moment';

    export default {
        name: "NoSoldProductReport",
        props: ['warehousesArr'],
        apollo: {
            $subscribe: {
                productCount: {
                    query: SUBSCRIBE_NO_SOLD_PRODUCTS_COUNT,
                    variables() {
                        return {
                            statement: no_sold_products_count_statement(this.startDate, this.endDate, this.warehouse||Constants.Warehouses.Katargam, this.hideZeroStockProduct),
                            aggregate: no_sold_products_aggregate,
                            // filter: this.search ? `%${this.search}%` : '%%',
                        }
                    },
                    result({data}) { this.productCount = data.productCount.aggregate.count }
                }
            },
            products: {
                query: GET_NO_SOLD_PRODUCTS,
                fetchPolicy: 'network-only',
                variables() {
                    return {
                        statement: no_sold_products_statement(this.startDate, this.endDate, this.warehouse||Constants.Warehouses.Katargam, this.hideZeroStockProduct, this.prepareSortString(this.sortBy, this.sortDesc)),
                        aggregate: no_sold_products_aggregate,
                        warehouseId: this.warehouse || Constants.Warehouses.Katargam,
                        offset: this.offset, limit: this.limit,
                        // filter: this.search ? `%${this.search}%` : '%%',
                    }
                }
            },
        },
        data () {
            return {
                Constants: Constants,
                moment: moment,
                search: '', loggedInUser: JSON.parse(localStorage.user),
                headers: [
                   /* { text: 'SKU', value: 'sku' },*/ { text: 'PRODUCT NAME', value: 'name', width:370 },
                    // { text: 'CATEGORY', value: 'productCategory', sortable:false },
                    { text: 'STOCK', value: 'stock', align:'end' },
                    { text: 'PRICE', value: 'displayPrice', align:'end' },
                    { text: 'TOTAL AMOUNT', value: 'totalAmount', align:'end' },
                ],
                products: [], productCount: 0,
                offset: 0, limit: 25, itemsPerPage: 25, rowsPerPageItems: [25, 50, 100, -1],
                warehouse: Constants.Warehouses.Katargam,
                selectedWarehouse: Constants.Warehouses.Katargam,
                startDate: moment().format('YYYY-MM-DDT00:00:00+05:30'),
                endDate: moment().format('YYYY-MM-DDT23:59:59+05:30'),
                lastDays: 1,
                hideZeroStockProduct: false,
                skipQuery: false,
                sortBy: ['name'], sortDesc: [false],
                galleryImages: [],
                galleryIndex: null
            }
        },
        computed:{
            disableApplyBtn(){
                return !this.lastDays || this.lastDays<=0
            }
        },
        methods:{
            prepareSortString([sortBy], [order]){
                order = order?'desc':'asc'
                if(['name', 'displayPrice'].includes(sortBy)) return `order by p."${sortBy}" ${order}`
                if(sortBy === 'stock') return `order by ws."totalQty" ${order}`
                if(sortBy === 'totalAmount') return `order by (ws."totalQty" * p."displayPrice") ${order}`
                return ''
            },
            updatePageNextPrev (pageNo) {
                this.offset = (pageNo - 1) * this.itemsPerPage;
                this.$vuetify.goTo(0);
            },
            updatePageItems (itemsPerPage) {
                this.itemsPerPage = itemsPerPage
                this.limit = itemsPerPage < 0 ? this.productCount : itemsPerPage
                this.offset = 0
            },
            onClearFilter(){
                this.products = []
            },
            getReportData(){
                if(this.lastDays && Number(this.lastDays)>0){
                    this.startDate = moment().subtract(Number(this.lastDays), 'days').format('YYYY-MM-DDT00:00:00+05:30')
                    this.warehouse = this.selectedWarehouse
                }
            },
            openGallery(arr){
                this.galleryImages = arr.map(m => {return {
                    href: this.imgWpx(m.path, 900, m.type),
                    type: m.type.toLowerCase() + '/' + m.path.split('.').pop()
                }})
                this.galleryIndex = 0
            },
            /*async exportCsv(){
                let str = this.headers.map(h=> h.text).join(',') + '\n'
                let {data:{Products}} = await this.$apollo.query({
                    query: GET_ALL_PRODUCTS_BY_WAREHOUSE,
                    fetchPolicy: 'network-only',
                    variables: { warehouseId: this.warehouse || Constants.Warehouses.Katargam,}
                })
                Products.forEach(p => {
                    str = str + p.sku +',' + p.name +',' + p.WarehouseStock[0]?.totalQty +',' +
                        p.displayPrice +',' + p.WarehouseStock[0]?.totalQty * p.displayPrice + '\n'
                })
                console.log('str', str)

                let blob = new Blob([str], {type: 'text/plain'});
                const a = window.document.createElement('a');
                a.href = window.URL.createObjectURL(blob);
                a.download = 'StockAmountReport' +'.csv';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } */
        }
    }
</script>

<style scoped>
#NoSoldProductReport{
    padding: 20px;
}
.avatar{
    cursor: pointer;
}
.ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
}
.product-name {
    display: inline-block;
    vertical-align: middle;
    width: 250px;
    max-width: 250px;
}
.last-day-field{
    max-width: 50px;
    margin: 8px 14px 0 14px;
    /*font-weight: bold;*/
}
.last-label{
    max-width: 50px;
    margin: 14px 0 0 0;
    /*font-weight: bold;*/
}
.branch-field{
    max-width: 20%;
    margin: 0 40px 0 40px;
}
.hide-product-checkbox{
    margin: 6px 16px 0 0;
}
</style>